import React from 'react';

const PageBanner = ({ title, subtitle, backgroundImage }) => {
    return (
        <div
            className="page-banner bg-cover bg-center"
            style={{ backgroundImage: `url(${backgroundImage})` }}
        >
            <div className="page-banner-overlay" />
            <div className="relative z-10 text-center px-4 animate-fade-up">
                <h1 className="text-white text-4xl md:text-6xl font-bold tracking-tight text-shadow">
                    {title}
                </h1>
                {subtitle && (
                    <p className="mt-3 text-white/90 text-base md:text-lg max-w-2xl mx-auto text-shadow">
                        {subtitle}
                    </p>
                )}
            </div>
        </div>
    );
};

export default PageBanner;
